import React, {useState} from 'react'
import './fpComp.scss';
import {useHistory} from 'react-router-dom';
import {useToast} from '../../../../helpers/commonFunction';
import {Http} from '../../../../helpers/axois';

const EmailVerification: React.FC = () => {
    const [ isInvalidEmail, setIsInvalidEmail ] = useState(false);
    const [ isApiLoading, setIsApiLoading ] = useState(false);
    const history = useHistory();
    const {ErrorToast, SuccessToast} = useToast();
    const [ emailId, setEmailId ] = useState('');

    function SendOtp() {
        if (emailId !== "") {
            try {
                setIsApiLoading(true)
                Http.get(`/email/${emailId}/dispatchOtp`).subscribe(
                    (response: any) => {
                        if (response.status === 200) {
                            SuccessToast(response.message)
                            history.push('/forgotPassword/otpVerification')
                            setIsInvalidEmail(false);
                            setIsApiLoading(false);
                            localStorage.setItem("resetPassword_emailId", emailId)
                        }
                    },
                    err => {
                        setIsApiLoading(false);
                        if ((err?.message).includes("Daily user sending limit exceeded.") || (err?.message).includes("Too many login attempts") ) {
                            ErrorToast("Alert! Your daily email limit exceeded, try again later.");
                        } else {
                            if ((err?.message).includes("No recipients defined")) {
                                setIsInvalidEmail(true);
                            }
                            ErrorToast(err?.message)
                        }
                    })
            } catch (e: any) {
                setIsApiLoading(false);
                ErrorToast(e?.message)
            }
        } else {
            setIsInvalidEmail(true);
        }
    }

    return (
        <div className='emailVerification w-full' >
            <div className='forgotPassword' >Forgot Your Password</div>
            <div className='subTitle' >Enter your username to reset it</div>
            <div style={{marginTop: "50px"}} >
                <input
                    value={emailId}
                    onChange={(e) => {setEmailId(e.target.value); setIsInvalidEmail(false)}}
                    placeholder='Email*'
                    id='emailInput'
                    className='emailInput'
                />
                {isInvalidEmail && <div className='validationTxt' >Please enter valid email address</div>}
            </div>
            <div style={{marginTop: "30px"}} >
                <button disabled={isApiLoading} onClick={() => SendOtp()} className='submitBtn' >Submit</button>
            </div>
        </div>
    )
}

export default EmailVerification;